import React from "react";

import { Button, Header, Icon, Modal } from "semantic-ui-react";

function RemoveModal({ handler, active, item, deleteCertificado }) {
  if (active) {
    return (
      <Modal
        basic
        onClose={() => handler(false)}
        onOpen={() => handler(true)}
        open={active}
        size="small"
      >
        <Header icon>
          <Icon name="archive" />
          Excluir Certificado
        </Header>
        <Modal.Content>
          <p>Deseja remover o Certificado {item.name}?</p>
        </Modal.Content>
        <Modal.Actions>
          <Button
            basic
            color="red"
            inverted
            onClick={() => {
              handler(false);
            }}
          >
            <Icon name="remove" /> Não
          </Button>
          <Button
            color="green"
            inverted
            onClick={() => {
              handler(false);
              deleteCertificado(item.id);
            }}
          >
            <Icon name="checkmark" /> Sim
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }

  return null;
}

export default RemoveModal;
